import { useRouter } from 'next/router';
import React, { useLayoutEffect, VFC } from 'react';

import PageLoader from '@/components/shared/utillities/loaders/PageLoader';
import User from '@/domain/core/User';

const decodeBase64Url = (value: string) => {
	const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
	const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');

	if (typeof window !== 'undefined' && typeof window.atob === 'function') {
		return window.atob(padded);
	}

	if (typeof Buffer !== 'undefined') {
		return Buffer.from(padded, 'base64').toString('utf8');
	}

	throw new Error('No base64 decoder available');
};

const isKeycloakState = (value: string | string[] | undefined) => {
	if (typeof value !== 'string' || !value) {
		return false;
	}

	try {
		const decoded = JSON.parse(decodeBase64Url(value)) as { provider?: string; nonce?: string };

		return decoded.provider === 'keycloak' && typeof decoded.nonce === 'string' && decoded.nonce.length > 0;
	} catch {
		return false;
	}
};

const IndexPage: VFC = () => {
	const { replace, query, isReady } = useRouter();
	const isProviderCallbackEntry =
		(typeof query.code === 'string' && typeof query.state === 'string') || typeof query.error === 'string';
	const isKeycloakCallback = isKeycloakState(query.state);

	useLayoutEffect(() => {
		if (!isReady) {
			return;
		}

		if (isProviderCallbackEntry) {
			replace({
				pathname: isKeycloakCallback ? '/auth/keycloak/callback' : '/auth/leader-id/callback',
				query,
			}).catch(console.error);
			return;
		}

		const path = (query.redirectUrl as string) || User.getInitialRedirectPath();
		replace(path).catch(console.error);
	}, [isReady, isKeycloakCallback, isProviderCallbackEntry, replace, query]);

	return <PageLoader />;
};

export default IndexPage;
